/* InstallDialogEditionHeader.tsx generated by @compiled/babel-plugin v0.36.0 */
import { ax, ix, CC, CS } from "@compiled/react/runtime";
import { media } from '@atlaskit/primitives';
import { isBugBountyParticipant } from '@atlassian/amkt-common';
import { useStatsig } from '@atlassian/mpac-feature-flags';
import { H5 } from '@atlassian/mpac-primitives';
import { AtlassianProductHostingType } from '@atlassian/mpac-types/graphql-gateway-types';
import React from 'react';
import { TEST_IDS } from '../../primitives/testIds';
import { CloudFortifiedAppBadge, CloudFortifiedAppBadgeSources } from '../CloudFortifiedAppBadge';
import { CloudSecurityParticipantBadge } from '../CloudSecurityParticipantBadge';
import DarkModeLogoBackground from '../DarkModeLogoBackground';
import { HeaderPartnerDetails } from '../HeaderPartnerDetails';
import { InstallCount, useInstallMessage } from '../InstallCount';
import { RunsOnAtlassianBadge } from '../RunsOnAtlassianBadge/RunsOnAtlassianBadge';
import * as utils from './AppHeader.utils';
import { ItemValue, TrustSignalsItem } from './AppHeaderV2.styles';
import { getAppIcon } from './components/HeaderAppIcon';
import HeaderRatings from './components/HeaderRatings';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const _38 = "._2hwxpxbi{margin-right:var(--ds-space-200,1pc)}";
const _37 = "._18u0pxbi{margin-left:var(--ds-space-200,1pc)}";
const _36 = "._4t3i1j6v{height:1rem}";
const _35 = "._bfhk7jlr{background-color:var(--ds-border-bold,#758195)}";
const _34 = "._1bsbt94y{width:1px}";
const _33 = "._1p57u2gc{row-gap:var(--ds-space-100,8px)}";
const _32 = "._1n261g80{flex-wrap:wrap}";
const _31 = "._4cvr1h6o{align-items:center}";
const _30 = "._1e0c1txw{display:flex}";
const _29 = "@media (min-width:48rem){._1b1qcs5v{grid-column:2}}";
const _28 = "._yyhy10xb{grid-column:1/3}";
const _27 = "._1ii7cs5v{grid-row:2}";
const _26 = "._1bto1l2s{text-overflow:ellipsis}";
const _25 = "._1e0ccj1k{display:-webkit-box}";
const _24 = "._sudp1e54{-webkit-box-orient:vertical}";
const _23 = "._1yyjkb7n{-webkit-line-clamp:1}";
const _22 = "._18m915vq{overflow-y:hidden}";
const _21 = "._1reo15vq{overflow-x:hidden}";
const _20 = "._1bsb1wug{width:auto}";
const _19 = "._yyhycs5v{grid-column:2}";
const _18 = "._yyhykb7n{grid-column:1}";
const _17 = "._1ii7kb7n{grid-row:1}";
const _16 = "@media (min-width:48rem){._1wkgu2gc{grid-row-gap:var(--ds-space-100,8px)}._19rdpxbi{grid-column-gap:var(--ds-space-200,1pc)}}";
const _15 = "._rerrutpp{grid-column-gap:var(--ds-space-150,9pt)}";
const _14 = "._ywjfpxbi{grid-row-gap:var(--ds-space-200,1pc)}";
const _13 = "._2z051d08{grid-template-rows:auto auto}";
const _12 = "._yv0e5bpd{grid-template-columns:auto 1fr}";
const _11 = "._1e0c11p5{display:grid}";
const _10 = "@media (min-width:48rem){._4puv1ejb{padding-bottom:var(--ds-space-300,24px)}}";
const _9 = "._1gnpidpf h2{margin-bottom:0}";
const _8 = "._n3tdpxbi{padding-bottom:var(--ds-space-200,1pc)}";
const _7 = "._n7zlpp12{border-bottom:var(--_18x9sjc)}";
const _6 = "@media (min-width:48rem){._6ytt1ejb{padding:var(--ds-space-300,24px)}}";
const _5 = "._1yt4pxbi{padding:var(--ds-space-200,1pc)}";
const _4 = "._19itpp12{border:var(--_18x9sjc)}";
const _3 = "._2rko1j6v{border-radius:1rem}";
const _2 = "._4t3iqf5o{height:3.25rem}";
const _ = "._1bsbqf5o{width:3.25rem}";
const appDetailsContainerStyles = null;
const iconContainerStyles = null;
const containerStyles = null;
const socialProofsStyles = null;
const trustSignalGridStyles = null;
const socialProofsSeparatorStyles = null;
const headerGridStyles = null;
const iconGridStyles = null;
const appDetailsGridStyles = null;
const headingEllipsisStyles = null;
const HeaderCertificationBadge = props => {
  if (props.isRunsOnAtlassianApp) {
    return /*#__PURE__*/_jsx(RunsOnAtlassianBadge, {});
  }
  if (props.isAppCloudFortified) {
    return /*#__PURE__*/_jsx(CloudFortifiedAppBadge, {
      showLabel: true,
      source: CloudFortifiedAppBadgeSources.InstallDialog
    });
  }
  if (isBugBountyParticipant(AtlassianProductHostingType.Cloud, props.bugBountyParticipant)) {
    return /*#__PURE__*/_jsx(CloudSecurityParticipantBadge, {
      showLabel: true
    });
  }
  return null;
};
const HeaderAppIcon = props => {
  const {
    appKey,
    origin,
    appIconLink,
    icon
  } = props;
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_, _2]
    }), /*#__PURE__*/_jsx("div", {
      className: ax(["_1bsbqf5o _4t3iqf5o"]),
      children: /*#__PURE__*/_jsx(DarkModeLogoBackground, {
        children: getAppIcon(origin, appKey, icon, appIconLink)
      })
    })]
  });
};

// eslint-disable-next-line max-lines-per-function, complexity
function InstallDialogEditionHeader(_ref) {
  var _appHeaderDetails$pro, _appHeaderDetails$pro2, _appHeaderDetails$com;
  let {
    appHeaderDetails,
    appIconLink,
    appRatingLink,
    headerInjection,
    isAppCloudFortified = false,
    openMarketplaceLinksInNewTab = true,
    bugBountyParticipant = null,
    isRunsOnAtlassianApp: runsOnAtlassianApp = false
  } = _ref;
  const {
    enableRunsOnAtlassian
  } = useStatsig();
  const isRunsOnAtlassianApp = enableRunsOnAtlassian() && (((_appHeaderDetails$pro = appHeaderDetails.programs) === null || _appHeaderDetails$pro === void 0 ? void 0 : (_appHeaderDetails$pro2 = _appHeaderDetails$pro.runsOnAtlassian) === null || _appHeaderDetails$pro2 === void 0 ? void 0 : _appHeaderDetails$pro2.status) || false) || runsOnAtlassianApp;
  const showNewAppMessage = utils.showNewAppMessage(appHeaderDetails);
  const showSecurityBadge = isAppCloudFortified || isBugBountyParticipant(AtlassianProductHostingType.Cloud, bugBountyParticipant) || isRunsOnAtlassianApp;
  const {
    tooltipMessage: installTooltipMessage,
    installCountMessage,
    showDownloadIcon,
    isLoading: isInstallMessageLoading
  } = useInstallMessage({
    distribution: appHeaderDetails.distribution,
    showNewAppMessage,
    compatibleProducts: (_appHeaderDetails$com = appHeaderDetails.compatibleProducts) !== null && _appHeaderDetails$com !== void 0 ? _appHeaderDetails$com : [],
    showAetherAppListingPage: true
  });
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_3, _4, _5, _6]
    }), /*#__PURE__*/_jsxs("div", {
      "data-testid": TEST_IDS.APP_HEADER,
      className: ax(["_2rko1j6v _19itpp12 _1yt4pxbi _6ytt1ejb"]),
      style: {
        "--_18x9sjc": ix("1px solid ".concat("var(--ds-border, #091E4224)"))
      },
      children: [/*#__PURE__*/_jsxs(CC, {
        children: [/*#__PURE__*/_jsx(CS, {
          children: [_7, _8, _9, _10]
        }), /*#__PURE__*/_jsx("div", {
          className: ax(["_n7zlpp12 _n3tdpxbi _1gnpidpf _4puv1ejb"]),
          style: {
            "--_18x9sjc": ix("1px solid ".concat("var(--ds-border, #091E4224)"))
          },
          children: /*#__PURE__*/_jsxs(CC, {
            children: [/*#__PURE__*/_jsx(CS, {
              children: [_11, _12, _13, _14, _15, _16]
            }), /*#__PURE__*/_jsxs("div", {
              className: ax(["_1e0c11p5 _yv0e5bpd _2z051d08 _ywjfpxbi _rerrutpp _1wkgu2gc _19rdpxbi"]),
              children: [/*#__PURE__*/_jsxs(CC, {
                children: [/*#__PURE__*/_jsx(CS, {
                  children: [_17, _18]
                }), /*#__PURE__*/_jsx("div", {
                  "data-testid": TEST_IDS.APP_HEADER_ICON,
                  className: ax(["_1ii7kb7n _yyhykb7n"]),
                  children: /*#__PURE__*/_jsx(HeaderAppIcon, {
                    origin: appHeaderDetails.origin,
                    icon: appHeaderDetails.icon,
                    appKey: appHeaderDetails.key,
                    appIconLink: appIconLink
                  })
                })]
              }), /*#__PURE__*/_jsxs(CC, {
                children: [/*#__PURE__*/_jsx(CS, {
                  children: [_17, _19, _20]
                }), /*#__PURE__*/_jsxs("div", {
                  className: ax(["_1ii7kb7n _yyhycs5v _1bsb1wug"]),
                  children: [/*#__PURE__*/_jsxs(CC, {
                    children: [/*#__PURE__*/_jsx(CS, {
                      children: [_21, _22, _23, _24, _25, _26]
                    }), /*#__PURE__*/_jsx(H5, {
                      as: "h2",
                      "data-testid": TEST_IDS.APP_HEADER_APP_NAME,
                      className: ax(["_1reo15vq _18m915vq _1yyjkb7n _sudp1e54 _1e0ccj1k _1bto1l2s"]),
                      children: appHeaderDetails.name
                    })]
                  }), /*#__PURE__*/_jsx(HeaderPartnerDetails, {
                    name: appHeaderDetails.partner.name,
                    link: appHeaderDetails.partner.link,
                    partnerTierType: appHeaderDetails.partner.partnerTierType
                  })]
                })]
              }), /*#__PURE__*/_jsxs(CC, {
                children: [/*#__PURE__*/_jsx(CS, {
                  children: [_27, _28, _29]
                }), /*#__PURE__*/_jsx("div", {
                  className: ax(["_1ii7cs5v _yyhy10xb _1b1qcs5v"]),
                  children: /*#__PURE__*/_jsxs(CC, {
                    children: [/*#__PURE__*/_jsx(CS, {
                      children: [_30, _31, _32, _33]
                    }), /*#__PURE__*/_jsxs("div", {
                      className: ax(["_1e0c1txw _4cvr1h6o _1n261g80 _1p57u2gc"]),
                      children: [!showNewAppMessage && /*#__PURE__*/_jsx(TrustSignalsItem, {
                        "data-testid": TEST_IDS.APP_HEADER_RATINGS,
                        children: /*#__PURE__*/_jsx(ItemValue, {
                          children: /*#__PURE__*/_jsx(HeaderRatings, {
                            appKey: appHeaderDetails.key,
                            appRatingLink: appRatingLink,
                            openMarketplaceLinksInNewTab: openMarketplaceLinksInNewTab,
                            ratings: appHeaderDetails.ratings
                          })
                        })
                      }), !!installCountMessage && /*#__PURE__*/_jsxs(CC, {
                        children: [/*#__PURE__*/_jsx(CS, {
                          children: [_34, _35, _36, _37, _38]
                        }), /*#__PURE__*/_jsx("div", {
                          className: ax(["_1bsbt94y _bfhk7jlr _4t3i1j6v _18u0pxbi _2hwxpxbi"])
                        })]
                      }), !!installCountMessage && /*#__PURE__*/_jsx(TrustSignalsItem, {
                        "data-testid": TEST_IDS.APP_HEADER_INSTALL_COUNT,
                        role: "img",
                        "aria-label": installTooltipMessage || '',
                        children: /*#__PURE__*/_jsx(ItemValue, {
                          children: /*#__PURE__*/_jsx(InstallCount, {
                            tooltipMessage: installTooltipMessage,
                            installCountMessage: installCountMessage,
                            showDownloadIcon: showDownloadIcon,
                            isLoading: isInstallMessageLoading
                          })
                        })
                      }), !!showSecurityBadge && /*#__PURE__*/_jsxs(CC, {
                        children: [/*#__PURE__*/_jsx(CS, {
                          children: [_34, _35, _36, _37, _38]
                        }), /*#__PURE__*/_jsx("div", {
                          className: ax(["_1bsbt94y _bfhk7jlr _4t3i1j6v _18u0pxbi _2hwxpxbi"])
                        })]
                      }), showSecurityBadge && /*#__PURE__*/_jsx(TrustSignalsItem, {
                        "data-testid": TEST_IDS.APP_HEADER_CERTIFICATION,
                        children: /*#__PURE__*/_jsx(ItemValue, {
                          children: /*#__PURE__*/_jsx(HeaderCertificationBadge, {
                            isRunsOnAtlassianApp: isRunsOnAtlassianApp,
                            isAppCloudFortified: isAppCloudFortified,
                            bugBountyParticipant: bugBountyParticipant
                          })
                        })
                      })]
                    })]
                  })
                })]
              })]
            })]
          })
        })]
      }), !!headerInjection && /*#__PURE__*/_jsx("div", {
        "data-testid": TEST_IDS.APP_HEADER_INJECTION,
        children: headerInjection
      })]
    })]
  });
}
export default InstallDialogEditionHeader;